import { i18n } from '@/i18n';
import ActorFormatter from '@/services/Formatter/ActorFormatter';
import { Actor, Payment, PaymentStatus, Status } from '@/types';

/**
 * Formatter pour différentes données d'un paiement.
 */
const PaymentFormatter = {
	formatStatus(payment: Payment, statusList: Array<PaymentStatus|Status>|null): void {
		let status = null;

		if (null === statusList ) {
			statusList = i18n.t('components.project.payments.status') as unknown as Status[];
		}

		status = statusList.find(item => payment.status === item.value);

		payment.status = undefined === status ? '' : ('label' in status ?  status.label :  status?.text);
	},
    getActorIdentifier(actor: Actor, payment: Payment): string {
        if (payment.actorData?.identifier) {
			return payment.actorData.identifier;
		}

		return ActorFormatter.formatActorIdentifier(actor);
    },
    getActorLabel(actor: Actor, payment: Payment): string {
        if (payment.actorData?.label) {
			return payment.actorData.label;
		}

		return ActorFormatter.formatActorLabel(actor);
    },
    isActorUpdated(actor: Actor, payment: Payment): boolean {
        if (payment.actorData?.identifier) {
			return payment.actorData.identifier !== ActorFormatter.formatActorIdentifier(actor);
		}

		return false;
    }
};

export default PaymentFormatter;
